var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_4981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5535 2.11133H4.13296C3.87164 2.11825 3.62361 2.22801 3.44276 2.41676C3.26192 2.60551 3.16286 2.85801 3.16712 3.11938V15.8811C3.16286 16.1424 3.26192 16.3949 3.44276 16.5837C3.62361 16.7724 3.87164 16.8822 4.13296 16.8891H14.868C15.1293 16.8822 15.3773 16.7724 15.5582 16.5837C15.739 16.3949 15.8381 16.1424 15.8338 15.8811V6.29133L11.5535 2.11133ZM11.0838 6.86133V3.08244L14.9366 6.86133H11.0838Z",
    fill: "#672EBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_4981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSolid);
export default __webpack_public_path__ + "static/media/document-solid.2d6770388175998a81c2e3092ecfaa59.svg";
export { ForwardRef as ReactComponent };